import $ from 'jquery';

$(function () {
    const $app = $('#sub-app');
    if (!$app.length) return;

    const optBadge = $app.data('sub-score-opt-badge') || 'Оптимальний';
    const optDesc = $app.data('sub-score-opt-desc') || 'У вас мінімалістичний та контрольований набір підписок. Витрати не перевантажують щомісячний бюджет.';
    const modBadge = $app.data('sub-score-mod-badge') || 'Помірний';
    const modDesc = $app.data('sub-score-mod-desc') || 'Середній рівень підпискового навантаження. Рекомендується переглянути сервіси, якими ви користуєтесь рідше одного разу на тиждень.';
    const critBadge = $app.data('sub-score-crit-badge') || 'Критичний';
    const critDesc = $app.data('sub-score-crit-desc') || 'Високий витік грошей! Ви витрачаєте значну суму на цифрові послуги. Оптимізація та сімейні плани збережуть солідний капітал.';
    const unitHours = $app.data('sub-unit-hours') || 'год';
    const monthlyLabel = $app.data('sub-monthly-label') || 'Щомісяця';
    const textMoreCurrencies = $app.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $app.data('text-more-short') || 'Ще';

    // Currency configs & typical costs
    const currencyConfigs = {
        UAH: { symbol: '₴', rate: 1.0, wage: 250, oppRate: 0.15, scoreOpt: 700, scoreMod: 2000 },
        USD: { symbol: '$', rate: 41.5, wage: 25, oppRate: 0.10, scoreOpt: 25, scoreMod: 65 },
        EUR: { symbol: '€', rate: 45.0, wage: 22, oppRate: 0.09, scoreOpt: 22, scoreMod: 60 },
        PLN: { symbol: 'zł', rate: 10.5, wage: 45, oppRate: 0.11, scoreOpt: 85, scoreMod: 250 },
        GBP: { symbol: '£', rate: 53.0, wage: 20, oppRate: 0.085, scoreOpt: 18, scoreMod: 50 },
        CHF: { symbol: 'Fr.', rate: 48.0, wage: 40, oppRate: 0.065, scoreOpt: 30, scoreMod: 80 },
        CAD: { symbol: 'C$', rate: 30.0, wage: 30, oppRate: 0.09, scoreOpt: 32, scoreMod: 85 },
        CZK: { symbol: 'Kč', rate: 1.80, wage: 280, oppRate: 0.10, scoreOpt: 500, scoreMod: 1400 }
    };

    let activeCurrency = $app.data('currency') || 'UAH';
    if (!currencyConfigs[activeCurrency]) {
        activeCurrency = 'UAH';
    }

    // Flexible Pre-configured Subscriptions with multi-currency pricing
    const defaultServices = [
        {
            id: 'youtube',
            name: 'YouTube Premium',
            category: 'streaming',
            icon: 'bx bx-play-circle text-danger',
            active: true,
            prices: { UAH: 99, USD: 14, EUR: 13, PLN: 26, GBP: 13, CHF: 16, CAD: 15, CZK: 180 }
        },
        {
            id: 'netflix',
            name: 'Netflix',
            category: 'streaming',
            icon: 'bx bx-tv text-danger',
            active: true,
            prices: { UAH: 300, USD: 15, EUR: 14, PLN: 43, GBP: 11, CHF: 18, CAD: 19, CZK: 260 }
        },
        {
            id: 'spotify',
            name: 'Spotify / Apple Music',
            category: 'music',
            icon: 'bx bx-music text-success',
            active: true,
            prices: { UAH: 130, USD: 11, EUR: 11, PLN: 24, GBP: 11, CHF: 14, CAD: 11, CZK: 170 }
        },
        {
            id: 'icloud',
            name: 'Apple iCloud / Google One',
            category: 'cloud_ai',
            icon: 'bx bx-cloud text-info',
            active: true,
            prices: { UAH: 50, USD: 3, EUR: 3, PLN: 15, GBP: 3, CHF: 3, CAD: 4, CZK: 60 }
        },
        {
            id: 'chatgpt',
            name: 'ChatGPT Plus / Claude',
            category: 'cloud_ai',
            icon: 'bx bx-bot text-primary',
            active: false,
            prices: { UAH: 830, USD: 20, EUR: 20, PLN: 85, GBP: 16, CHF: 18, CAD: 27, CZK: 460 }
        },
        {
            id: 'megogo',
            name: 'Megogo / Sweet.tv',
            category: 'streaming',
            icon: 'bx bx-film text-warning',
            active: false,
            prices: { UAH: 199, USD: 10, EUR: 9, PLN: 35, GBP: 8, CHF: 10, CAD: 12, CZK: 190 }
        },
        {
            id: 'telegram',
            name: 'Telegram Premium',
            category: 'productivity',
            icon: 'bx bx-paper-plane text-info',
            active: true,
            prices: { UAH: 120, USD: 5, EUR: 5, PLN: 20, GBP: 4, CHF: 5, CAD: 6, CZK: 110 }
        },
        {
            id: 'psplus',
            name: 'PlayStation / Xbox Game Pass',
            category: 'gaming',
            icon: 'bx bx-joystick text-primary',
            active: false,
            prices: { UAH: 350, USD: 15, EUR: 15, PLN: 55, GBP: 13, CHF: 16, CAD: 19, CZK: 320 }
        },
        {
            id: 'vpn',
            name: 'VPN (NordVPN / Surfshark)',
            category: 'productivity',
            icon: 'bx bx-shield-alt-2 text-info',
            active: false,
            prices: { UAH: 150, USD: 4, EUR: 4, PLN: 16, GBP: 3, CHF: 4, CAD: 5, CZK: 85 }
        },
        {
            id: 'duolingo',
            name: 'Duolingo / Learning',
            category: 'productivity',
            icon: 'bx bx-book-open text-success',
            active: false,
            prices: { UAH: 200, USD: 8, EUR: 8, PLN: 30, GBP: 7, CHF: 9, CAD: 10, CZK: 170 }
        },
        {
            id: 'fitness',
            name: 'Fitness / Strava / Gym',
            category: 'productivity',
            icon: 'bx bx-run text-danger',
            active: false,
            prices: { UAH: 300, USD: 12, EUR: 11, PLN: 45, GBP: 10, CHF: 13, CAD: 15, CZK: 250 }
        },
        {
            id: 'software',
            name: 'GitHub / Figma / Notion',
            category: 'productivity',
            icon: 'bx bx-code-alt text-primary',
            active: false,
            prices: { UAH: 415, USD: 10, EUR: 10, PLN: 42, GBP: 8, CHF: 10, CAD: 14, CZK: 230 }
        }
    ];

    let services = defaultServices.map(s => ({
        ...s,
        price: s.prices[activeCurrency] || Math.round(s.prices.UAH / (currencyConfigs[activeCurrency].rate || 1))
    }));

    let activeFilter = 'all';
    let hourlyWage = currencyConfigs[activeCurrency].wage;

    function formatMoney(num) {
        if (isNaN(num) || !isFinite(num)) num = 0;
        const cfg = currencyConfigs[activeCurrency];
        return `${Math.round(num).toLocaleString()} ${cfg.symbol}`;
    }

    function calculateOpportunityCost(monthlyAmount, rateAnnual = 0.15) {
        const r = rateAnnual / 12;
        // FV = P * ((1+r)^n - 1) / r
        function fv(months) {
            return monthlyAmount * ((Math.pow(1 + r, months) - 1) / r);
        }
        return {
            threeYears: fv(36),
            fiveYears: fv(60),
            tenYears: fv(120)
        };
    }

    function renderCards() {
        const $container = $('#sub-cards-container');
        $container.empty();
        const cfg = currencyConfigs[activeCurrency];

        const filtered = activeFilter === 'all' 
            ? services 
            : services.filter(s => s.category === activeFilter);

        filtered.forEach((service) => {
            const cardBgStyle = service.active ? 'background-color: rgba(var(--bs-primary-rgb), 0.06);' : '';
            const cardHtml = `
                <div class="col-sm-6 col-md-4 col-xl-3 sub-service-col" data-service-id="${service.id}">
                    <div class="card h-100 sub-service-card border ${service.active ? 'border-primary shadow-sm' : 'border-light'} p-3" style="transition: all 0.2s ease; cursor: pointer; ${cardBgStyle}">
                        <div class="d-flex align-items-center justify-content-between mb-2">
                            <div class="avatar-xs rounded-circle bg-light border d-inline-flex align-items-center justify-content-center shadow-sm">
                                <i class="${service.icon.includes('bx') ? service.icon : 'bx ' + service.icon} font-size-18"></i>
                            </div>
                            <div class="form-check form-switch m-0">
                                <input class="form-check-input sub-toggle" type="checkbox" data-id="${service.id}" ${service.active ? 'checked' : ''} style="cursor: pointer;">
                            </div>
                        </div>
                        <h6 class="fw-bold text-body font-size-14 mb-2 text-truncate" title="${service.name}">${service.name}</h6>
                        <div class="mt-auto pt-2 border-top">
                            <div class="d-flex align-items-center justify-content-between">
                                <span class="text-muted font-size-11">${monthlyLabel}</span>
                                <div class="input-group input-group-sm" style="width: 120px;" onclick="event.stopPropagation();">
                                    <input type="number" class="form-control form-control-sm font-size-12 sub-price-input text-end fw-semibold" data-id="${service.id}" value="${service.price}" min="0" step="1" ${!service.active ? 'disabled' : ''}>
                                    <span class="input-group-text bg-light text-muted font-size-11">${cfg.symbol}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            $container.append(cardHtml);
        });
    }

    function calculateAndRenderResults() {
        const cfg = currencyConfigs[activeCurrency];
        const activeServices = services.filter(s => s.active);
        const monthlyTotal = activeServices.reduce((acc, s) => acc + (parseFloat(s.price) || 0), 0);
        const annualTotal = monthlyTotal * 12;

        const opp = calculateOpportunityCost(monthlyTotal, cfg.oppRate);

        const safeWage = hourlyWage > 0 ? hourlyWage : cfg.wage;
        const workHoursPerMonth = (monthlyTotal / safeWage).toFixed(1);

        // Update KPIs
        $('#sub-kpi-monthly').text(formatMoney(monthlyTotal));
        $('#sub-kpi-annual').text(formatMoney(annualTotal));
        $('#sub-kpi-opp-5y').text(formatMoney(opp.fiveYears));
        $('#sub-kpi-work-hours').text(`${workHoursPerMonth} ${unitHours}`);

        $('#sub-active-count-badge').text(activeServices.length);

        // Opportunity Cost Breakdown
        $('#sub-opp-3y-val').text(formatMoney(opp.threeYears));
        $('#sub-opp-5y-val').text(formatMoney(opp.fiveYears));
        $('#sub-opp-10y-val').text(formatMoney(opp.tenYears));

        // Load Index & Score
        const $scoreBadge = $('#sub-score-badge');
        const $scoreDesc = $('#sub-score-desc');

        if (monthlyTotal < cfg.scoreOpt) {
            $scoreBadge.removeClass('bg-warning bg-danger text-dark').addClass('bg-success text-white').text(optBadge);
            $scoreDesc.text(optDesc);
        } else if (monthlyTotal <= cfg.scoreMod) {
            $scoreBadge.removeClass('bg-success bg-danger text-white').addClass('bg-warning text-dark').text(modBadge);
            $scoreDesc.text(modDesc);
        } else {
            $scoreBadge.removeClass('bg-success bg-warning text-dark').addClass('bg-danger text-white').text(critBadge);
            $scoreDesc.text(critDesc);
        }
    }

    function updateCurrencyUI() {
        const cfg = currencyConfigs[activeCurrency];
        $('.sub-currency-symbol').text(cfg.symbol);

        services.forEach(s => {
            if (s.prices && s.prices[activeCurrency] !== undefined) {
                s.price = s.prices[activeCurrency];
            } else if (s.prices && s.prices.UAH) {
                s.price = Math.round(s.prices.UAH / (cfg.rate || 1));
            }
        });

        hourlyWage = cfg.wage;
        $('#sub-wage-input').val(hourlyWage);

        renderCards();
        calculateAndRenderResults();
    }

    // Toggle service via checkbox
    $(document).on('change', '.sub-toggle', function (e) {
        e.stopPropagation();
        const id = $(this).data('id');
        const checked = $(this).is(':checked');
        const s = services.find(x => x.id === id);
        if (s) {
            s.active = checked;
            renderCards();
            calculateAndRenderResults();
        }
    });

    // Toggle service via card click
    $(document).on('click', '.sub-service-card', function (e) {
        if ($(e.target).is('input') || $(e.target).closest('.input-group').length) return;
        const $switch = $(this).find('.sub-toggle');
        $switch.prop('checked', !$switch.prop('checked')).trigger('change');
    });

    // Update price on input change
    $(document).on('input change', '.sub-price-input', function (e) {
        e.stopPropagation();
        const id = $(this).data('id');
        const val = Math.max(0, parseFloat($(this).val()) || 0);
        const s = services.find(x => x.id === id);
        if (s) {
            s.price = val;
            calculateAndRenderResults();
        }
    });

    // Filter switching
    $('[data-sub-filter]').on('click', function () {
        $('[data-sub-filter]').removeClass('btn-primary text-white').addClass('btn-light text-body');
        $(this).removeClass('btn-light text-body').addClass('btn-primary text-white');
        activeFilter = $(this).data('sub-filter');
        renderCards();
    });

    // Presets
    $('[data-sub-preset]').on('click', function () {
        $('[data-sub-preset]').removeClass('btn-primary text-white').addClass('btn-light text-body');
        $(this).removeClass('btn-light text-body').addClass('btn-primary text-white');

        const preset = $(this).data('sub-preset');
        if (preset === 'minimal') {
            services.forEach(s => s.active = ['youtube', 'icloud'].includes(s.id));
        } else if (preset === 'typical') {
            services.forEach(s => s.active = ['youtube', 'netflix', 'spotify', 'icloud', 'telegram'].includes(s.id));
        } else if (preset === 'digital') {
            services.forEach(s => s.active = ['youtube', 'spotify', 'icloud', 'chatgpt', 'vpn', 'software', 'telegram'].includes(s.id));
        } else if (preset === 'family') {
            services.forEach(s => s.active = ['youtube', 'netflix', 'spotify', 'icloud', 'megogo', 'duolingo', 'fitness', 'psplus'].includes(s.id));
        }

        renderCards();
        calculateAndRenderResults();
    });

    // Hourly Wage change
    $('#sub-wage-input, #sub-hourly-wage').on('input change', function () {
        hourlyWage = parseFloat($(this).val()) || currencyConfigs[activeCurrency].wage;
        calculateAndRenderResults();
    });

    // Currency selection (Direct tabs)
    $(document).on('click', '#sub-currency-tabs > button[data-currency]', function () {
        $('#sub-currency-tabs button').removeClass('active');
        $(this).addClass('active');
        $('.sub-more-currencies-btn').removeClass('active');
        $('.sub-currency-dropdown-item').removeClass('active');
        $('#sub-active-custom-currency').html(`
            <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
            <span class="d-sm-none">${textMoreShort}</span>
        `);

        activeCurrency = $(this).data('currency');
        updateCurrencyUI();
    });

    // Currency selection (Dropdown items)
    $(document).on('click', '.sub-currency-dropdown-item', function (e) {
        e.preventDefault();
        const selCurr = $(this).data('currency');
        const selSymbol = $(this).data('symbol') || '$';

        $('#sub-currency-tabs > button[data-currency]').removeClass('active');
        $('.sub-currency-dropdown-item').removeClass('active');
        $(this).addClass('active');

        $('.sub-more-currencies-btn').addClass('active');
        $('#sub-active-custom-currency').text(`${selSymbol} ${selCurr}`);

        activeCurrency = selCurr;
        updateCurrencyUI();
    });

    // Add Custom Subscription
    $('#sub-btn-add-custom').on('click', function () {
        const name = $('#sub-custom-name').val().trim();
        const price = parseFloat($('#sub-custom-price').val()) || 0;

        if (!name) {
            $('#sub-custom-name').focus();
            return;
        }

        const newId = `custom_${Date.now()}`;
        services.push({
            id: newId,
            name: name,
            category: 'productivity',
            icon: 'bx bx-star text-warning',
            active: true,
            price: price > 0 ? price : 10,
            prices: { [activeCurrency]: price > 0 ? price : 10 }
        });

        $('#sub-custom-name').val('');
        $('#sub-custom-price').val('');

        renderCards();
        calculateAndRenderResults();
    });

    // Initial render
    updateCurrencyUI();
});
